import dayjs from "dayjs";
import "dayjs/locale/es";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);
dayjs.locale("es");

export { dayjs };

export function initials(name, wa) {
  if (name && name.trim()) {
    return name.trim().split(" ").slice(0, 2).map((p) => p[0]?.toUpperCase()).join("");
  }
  return (wa || "?").replace(/\D/g, "").slice(-2) || "?";
}

export function displayPhone(wa) {
  if (!wa) return "";
  if (wa.startsWith("sim-")) return `Simulador · ${wa.slice(4)}`;
  return `+${wa}`;
}

export function money(n, currency = "USD") {
  try {
    return new Intl.NumberFormat("es", { style: "currency", currency }).format(n || 0);
  } catch {
    return `${(n || 0).toFixed(2)} ${currency}`;
  }
}

const PALETTE = [
  "bg-emerald-100 text-emerald-800", "bg-sky-100 text-sky-800", "bg-amber-100 text-amber-800",
  "bg-rose-100 text-rose-800", "bg-violet-100 text-violet-800", "bg-lime-100 text-lime-800",
  "bg-orange-100 text-orange-800", "bg-cyan-100 text-cyan-800",
];

export function tagColor(tag) {
  let h = 0;
  for (const c of tag) h = (h * 31 + c.charCodeAt(0)) >>> 0;
  return PALETTE[h % PALETTE.length];
}

const AVATARS = ["bg-emerald-600", "bg-sky-600", "bg-amber-600", "bg-rose-600", "bg-indigo-600", "bg-teal-700"];
export function avatarColor(seed = "") {
  let h = 0;
  for (const c of seed) h = (h * 17 + c.charCodeAt(0)) >>> 0;
  return AVATARS[h % AVATARS.length];
}

export const ORDER_STATUS = {
  nuevo: { label: "Nuevo", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  confirmado: { label: "Confirmado", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  entregado: { label: "Entregado", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  cancelado: { label: "Cancelado", cls: "bg-rose-50 text-rose-700 border-rose-200" },
};
